import React, { useEffect, useState } from 'react';
import './slider.scss';
import propTypes from 'prop-types';
import { Tooltip } from '../../common';

const Slider = ({ passengerList, handleOnClick, isFlightInvoice = false }) => {
  let mouseDown = false;
  let startX, scrollLeft;
  useEffect(() => {
    setSelect(isFlightInvoice ? 0 : -1);
  }, [passengerList]);
  useEffect(() => {
    const slider = document.getElementById('passebgerSlide');
    let startDragging = function (e) {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };
    let stopDragging = function (event) {
      mouseDown = false;
    };

    slider.addEventListener('mousemove', (e) => {
      e.preventDefault();
      if (!mouseDown) {
        return;
      }
      slider.style.cursor = 'grabbing';
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    });

    // Add the event listeners
    slider.addEventListener('mousedown', startDragging, false);
    slider.addEventListener('mouseup', stopDragging, false);
    slider.addEventListener('mouseleave', stopDragging, false);
  }, []);

  const slider = document.getElementById('passebgerSlide');
  let [select, setSelect] = useState(isFlightInvoice ? 0 : -1);
  return (
    <>
      <div
        id="passebgerSlide"
        className={` d-flex  overflow-hidden position-relative w-100 mx-sm-0 px-sm-0 justify-content-start  user-select-none
        align-self-center side_nav cursor-pointer`}
        style={{
          maxWidth: '100%',
          zIndex: '2',
          marginRight: '-1px',
          scrollBehavior: 'smooth',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {passengerList.map((item, index) => {
          let fullName = `${item.firstName} ${item.lastName}`;

          return (
            <div
              key={item._id}
              className="itemOfSliderSize pt-1 side_nav h-100 d-flex flex-column align-items-center justify-content-center 
              default-border-top-radius-xsmall  "
              style={{
                direction: 'ltr',
                height: '4rem',
                minWidth: '8rem',
                backgroundColor:
                  select == item._id
                    ? 'rgb(44, 53, 202, 0.5)'
                    : index == 0 && select == 0
                    ? 'rgb(44, 53, 202, 0.5)'
                    : '',
              }}
              onClick={() => {
                setSelect(item._id);
                handleOnClick(item);
              }}
            >
              <img
                src={require(`../../../content/images/avatars/${
                  item.avatar ? item.avatar : '1.png'
                }`)}
                alt="user image"
                // width="50px"
                // height="50px"
                className="pictureOfPassenger p-1"
                draggable="false"
              />
              <div className="pt-1 text-center  col-8 px-0 font-smaller font-sm-xsmall font-lg-smaller user-select-none">
                <Tooltip
                  position={'top'}
                  content={fullName}
                  direction="ltr"
                  backgroundColor="warning"
                  textColor="dark"
                >
                  <span className="w-100 text-nowrap user-select-none">
                    {fullName.length > 12
                      ? fullName.substring(0, 12).concat('...')
                      : fullName}
                  </span>
                </Tooltip>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
Slider.propTypes = {
  passengerList: propTypes.array,
};
Slider.defaultProps = {
  passengerList: [],
  fieldName: ['id'],
};
export default Slider;
